import { render, staticRenderFns } from "@/modules/Message/templates/messages-list.html?vue&type=template&id=4a373680&scoped=true&"
import script from "@/modules/Message/scripts/messages-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Message/scripts/messages-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Message/styles/messages-list.scss?vue&type=style&index=0&id=4a373680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a373680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
